import { Component, Input } from '@angular/core';
import { IBaseModel } from '../../../models/base.model';
import { IAcaoPlanoAcaoEvidenciaAuditorModel, IAcaoPlanoAcaoEvidenciaModel, IAcaoPlanoAcaoHistoricoEvidenciaModel, IAcaoPlanoAcaoHistoricoModel } from '../../../models/plano-acao-model';
import { PlanoAcaoService } from '../../../services/plano-acao.service';
import Swal from 'sweetalert2';

// Demanda 68742 linha 41 – consulta readonly de ciclo anterior (protótipos 4.1.2/4.3).
@Component({
  selector: 'app-plano-acao-historico-ciclo',
  templateUrl: './plano-acao-historico-ciclo.component.html',
  styleUrls: ['./plano-acao-historico-ciclo.component.scss']
})
export class PlanoAcaoHistoricoCicloComponent {

  @Input() ciclo: IAcaoPlanoAcaoHistoricoModel;
  @Input() identificador: number;
  @Input() somenteImplementacao = false;

  constructor(private planoAcaoService: PlanoAcaoService) {
  }

  public download(evidencia: IAcaoPlanoAcaoHistoricoEvidenciaModel): void {
    this.baixarEvidencia(evidencia, (id) => this.planoAcaoService.downloadEvidencia(id));
  }

  public downloadAuditor(evidencia: IAcaoPlanoAcaoHistoricoEvidenciaModel): void {
    this.baixarEvidencia(evidencia, (id) => this.planoAcaoService.downloadEvidenciaAuditor(id));
  }

  private baixarEvidencia(
    evidencia: IAcaoPlanoAcaoHistoricoEvidenciaModel,
    obterDownload: (id: number) => Promise<IBaseModel<IAcaoPlanoAcaoEvidenciaModel | IAcaoPlanoAcaoEvidenciaAuditorModel>>
  ): void {
    if (!evidencia?.evidenciaOrigemId) {
      return;
    }
    obterDownload(evidencia.evidenciaOrigemId).then((res) => {
      if (res.sucesso) {
        const link = document.createElement('a');
        link.href = res.dados.link.toString();
        link.download = res.dados.nome;
        link.click();
      } else {
        Swal.fire({ toast: true, position: 'top-end', icon: 'warning', text: res.mensagem.descricao, showConfirmButton: false, timer: 5000, timerProgressBar: true });
      }
    });
  }
}
